import styled from 'styled-components';

type ColumnItemProps = {
  paddingVertical?: number;
  paddingHorizontal?: number;
};

const ColumnItem = styled.div<ColumnItemProps>`
  width: 50%;
  padding: ${(p) => {
    let paddingVertical = p.paddingVertical ? p.paddingVertical : '24';
    let paddingHorizontal = p.paddingHorizontal ? p.paddingHorizontal : '24';

    return `${paddingVertical}px ${paddingHorizontal}px`;
  }};
`;

export default ColumnItem;
